import { configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { rootReducer } from './reducer';

// Define the configuration for Redux Persist
const persistConfig = {
  key: 'root',
  storage,
};

// Create a persisted reducer using Redux Persist configuration
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Configure the Redux store
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }),
  devTools: import.meta.env.NODE_ENV !== 'production',
});

// Define types for RootState and AppDispatch
export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;

// Define types for RootState and AppDispatch
export const useAppDispatch = () => useDispatch<AppDispatch>();

// Create a custom hook for using the dispatch function
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

// Create a persistor for Redux Persist
export const persistor = persistStore(store);
